/**
 * Category enum for place classification
 */
export enum Category {
  ABSINTH = 1,
  BOURBON,
  COGNAC,
  TEA,
  CHOCOLATE,
  FORTIFIED_WINES,
  GIN,
  COFFEE,
  SPICES_AND_HERBS,
  LIQUEURS,
  MEAT,
  MEZCAL,
  SEAFOOD,
  NONALCOHOLIC_DRINKS,
  FRUIT_DESTILATES,
  BEER,
  RUM,
  FISHES,
  CHEESE,
  TOBACCO,
  TEQUILA,
  WINE,
  VODKA,
  WHISKEY,
}

/**
 * Coordinates interface
 */
export interface Coordinates {
  lat: number;
  lon: number;
  alt: number;
}

/**
 * Place interface representing a location on the map
 */
export interface Place {
  id: string;
  title: string;
  description: string;
  coordinates: Coordinates[];
  categories: Category[];
  websiteURL: string | null;
  brandLogo: string | null;
  customHTML: string | null;
}

/**
 * Filter state interface
 */
export interface FilterState {
  searchQuery: string;
  selectedCategories: Set<Category>;
}

/**
 * API Response interface
 */
export interface ApiResponse {
  places: unknown[];
  success: boolean;
  message?: string;
}
